// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2GW40","left":"InfoRow_left__Ujz8N"};